import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "notice"]

  disconnect() {
    document.body.classList.remove("admin-marketing-overlay-open")
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return
    this.opener = document.activeElement
    this.dialogTarget.hidden = false
    document.body.classList.add("admin-marketing-overlay-open")
    window.requestAnimationFrame(() => this.dialogTarget.querySelector("input[type='text']")?.focus())
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget || this.dialogTarget.hidden) return
    this.dialogTarget.hidden = true
    document.body.classList.remove("admin-marketing-overlay-open")
    this.opener?.focus()
  }

  requireSave(event) {
    if (this.hasNoticeTarget) this.noticeTarget.hidden = false
    this.open(event)
  }

  trapFocus(event) {
    if (!this.hasDialogTarget || this.dialogTarget.hidden) return
    const fields = Array.from(this.dialogTarget.querySelectorAll("button:not([disabled]), input:not([type='hidden']), a[href]"))
      .filter(node => node.getClientRects().length && !node.classList.contains("admin-marketing-dialog-backdrop"))
    const first = fields[0], last = fields[fields.length - 1]
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus() }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus() }
  }
}
